export default __webpack_public_path__ + "static/media/riotgames.0fe1faef.svg";